import { useEffect, useLayoutEffect, useState } from "react";
import { useVantageContext } from "../../../../context/vantageContext";
import useRestoreFocus from "../../../../hooks/useRestoreFocus";
var useCreditHeaderModalLogic = function () {
    var _a = useRestoreFocus(), questionsAboutCreditStoreRef = _a.ref, restoreFocusToQuestionsAboutCreditScoreRef = _a.restoreFocusToRef;
    var _b = useRestoreFocus(), whatDoesCreditScoreMeanRef = _b.ref, restoreFocusToWhatDoesCreditScoreMeanRef = _b.restoreFocusToRef;
    var _c = useVantageContext(), _d = _c.state, isCrossBorderModalOpen = _d.crossBorderModal.isOpen, reopenQuestionsModal = _d.reopenQuestionsModal, restoreFocus = _c.restoreFocus, dispatch = _c.dispatch;
    var _e = useState(false), isCreditQuestionsModalOpen = _e[0], setIsCreditQuestionsModalOpen = _e[1];
    var _f = useState(false), isCreditTooltipModalOpen = _f[0], setIsCreditTooltipModalOpen = _f[1];
    var openCreditQuestionsModal = function () { return setIsCreditQuestionsModalOpen(true); };
    var closeCreditQuestionsModal = function () { return setIsCreditQuestionsModalOpen(false); };
    var openCreditToolTipModal = function () { return setIsCreditTooltipModalOpen(true); };
    var closeCreditToolTipModal = function () {
        setIsCreditTooltipModalOpen(false);
        restoreFocusToWhatDoesCreditScoreMeanRef();
    };
    useEffect(function () {
        if (isCrossBorderModalOpen)
            closeCreditQuestionsModal();
    }, [isCrossBorderModalOpen]);
    useEffect(function () {
        if (reopenQuestionsModal) {
            openCreditQuestionsModal();
            dispatch({
                reopenQuestionsModal: false,
            });
        }
    }, [dispatch, reopenQuestionsModal]);
    useLayoutEffect(function () {
        if (isCreditQuestionsModalOpen) {
            restoreFocus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCreditQuestionsModalOpen]);
    return {
        questionsAboutCreditStoreRef: questionsAboutCreditStoreRef,
        whatDoesCreditScoreMeanRef: whatDoesCreditScoreMeanRef,
        restoreFocusToQuestionsAboutCreditScoreRef: restoreFocusToQuestionsAboutCreditScoreRef,
        restoreFocusToWhatDoesCreditScoreMeanRef: restoreFocusToWhatDoesCreditScoreMeanRef,
        isCreditQuestionsModalOpen: isCreditQuestionsModalOpen,
        isCreditTooltipModalOpen: isCreditTooltipModalOpen,
        openCreditQuestionsModal: openCreditQuestionsModal,
        closeCreditQuestionsModal: closeCreditQuestionsModal,
        openCreditToolTipModal: openCreditToolTipModal,
        closeCreditToolTipModal: closeCreditToolTipModal,
    };
};
export default useCreditHeaderModalLogic;
